import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import useAppState from '../../hooks/useAppState'
import { LoadingPage } from '../../components/LoadingPage'
import { useOrganizationDetail } from '../../apiLayer/queryHooks/queries'
import { getActiveOrganizationId } from './orgStateHelpers'
import { getOnboardingRedirectPathIfPending, isOrgOnboardingPath } from './orgOnboardingNavigation'

type OrgAdminOnboardingRedirectProps = {
  children: React.ReactNode
}

/**
 * Wraps the facilitator shell. Org admins whose active tenant is still
 * `PENDING_ONBOARDING` are sent to the onboarding wizard until the org is ACTIVE.
 */
export function OrgAdminOnboardingRedirect({ children }: OrgAdminOnboardingRedirectProps) {
  const { state } = useAppState()
  const location = useLocation()
  const activeOrganizationId = getActiveOrganizationId(state.user)
  const orgDetail = useOrganizationDetail(activeOrganizationId)

  if (!state.isAuthInitialized || !state.user?.id) {
    return <>{children}</>
  }

  if (!activeOrganizationId) {
    return <>{children}</>
  }

  if (isOrgOnboardingPath(location.pathname)) {
    return <>{children}</>
  }

  if (orgDetail.isLoading) {
    return <LoadingPage />
  }

  const redirectPath = getOnboardingRedirectPathIfPending(
    state.user,
    orgDetail.data?.data?.status,
    activeOrganizationId
  )

  if (redirectPath) {
    return <Navigate to={redirectPath} replace />
  }

  return <>{children}</>
}
